import type { LocalDate } from '@saay/formatting';
import { Field } from '@saay/shadcn/components/field';
import { SolarDateField, type SolarDateFieldProps } from '@saay/ui';
import type { ReactNode } from 'react';

/** Single Solar date bound to API `LocalDate` strings (XAP-10, D1). */
export function AdminSolarDateField({
  disabled,
  error,
  hint,
  id,
  label,
  max,
  min,
  name,
  onBlur,
  onChange,
  value,
}: {
  readonly disabled?: boolean;
  readonly error?: string | undefined;
  readonly hint?: ReactNode;
  readonly id?: string;
  readonly label: ReactNode;
  readonly max?: LocalDate;
  readonly min?: LocalDate;
  readonly name?: string;
  readonly onBlur?: () => void;
  readonly onChange: (value: string) => void;
  readonly value: string;
}) {
  const props: SolarDateFieldProps = {
    label,
    onChange: (next) => onChange(next === '' ? '' : next),
    value: value === '' ? '' : (value as LocalDate),
    ...(disabled === undefined ? {} : { disabled }),
    ...(error === undefined ? {} : { error }),
    ...(hint === undefined ? {} : { hint }),
    ...(id === undefined ? {} : { id }),
    ...(max === undefined ? {} : { max }),
    ...(min === undefined ? {} : { min }),
    ...(name === undefined ? {} : { name }),
  };
  return (
    <Field className="w-full" onBlur={onBlur === undefined ? undefined : () => onBlur()}>
      <SolarDateField {...props} />
    </Field>
  );
}
